import { render, staticRenderFns } from "./Lgx441663084428263424.vue?vue&type=template&id=2536062c&scoped=true&"
import script from "./Lgx441663084428263424.vue?vue&type=script&lang=js&"
export * from "./Lgx441663084428263424.vue?vue&type=script&lang=js&"
import style0 from "./Lgx441663084428263424.vue?vue&type=style&index=0&id=2536062c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536062c",
  null
  
)

export default component.exports